module.exports = __webpack_public_path__ + "static/media/news-transparent-bottom-card.41d03253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-transparent-bottom-card.png
// module id = 1002
// module chunks = 0